<template>
  <span>
    <svg
      v-if="name === 'service-charge'"
      height="30"
      width="30"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 576 512"
    >
      <!--! Font Awesome Pro 6.5.1 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license (Commercial License) Copyright 2023 Fonticons, Inc. -->
      <path
        d="M416 144a144 144 0 1 0 -288 0 144 144 0 1 0 288 0zM248.8 111.4c-.4 .7-.9 1.6-.8 3.6l0 .1c0 .4 0 1.9 4.8 4.5c5.6 3 13.5 5.2 23.9 8.2l.2 0c9.3 2.6 21.1 6 30.5 11.5c10.2 6 20 16.1 20.5 32.3c.5 18.2-9.7 30.4-21.7 36.9c-5.8 3.1-12.1 5.1-18.3 6.2v10.8 16H256v-16V214.1c-8.6-1.7-16.7-4.3-23.7-6.6l0 0 0 0c-1.7-.6-3.4-1.1-5-1.6L212 201.2l9.5-30.6 15.3 4.8c2 .6 3.9 1.2 5.8 1.8c11.5 3.6 20.4 6.5 29.9 6.8c6.7 .2 13.8-1.1 18.5-3.6c2.2-1.2 3.4-2.4 4-3.3c.5-.8 1.1-2.1 1-4.5c0-1.4-.2-3-4.7-5.6c-5.3-3.1-12.9-5.4-23.2-8.3l-1.8-.5c-8.9-2.5-19.8-5.6-28.6-10.3c-9.9-5.3-20.6-14.7-21.6-30.7c-1.2-18.8 10-30.9 21.8-37.2c5.7-3.1 12-5.1 18-6.3V64 48h32V64v9.4c6.3 .9 12.3 2.3 17.9 3.7l15.5 3.9-7.7 31.1-15.5-3.9c-9.3-2.3-18.2-4-26.4-4.1c-6.2-.1-13.6 1.3-18.7 4c-2.4 1.3-3.6 2.5-4.2 3.4zM140 327L68.8 384H0V512H32 224 384h12.4l10.2-7 128-88 33-22.7-45.3-65.9-33 22.7-94.5 65H256V384h32 64 32V320H352 288 224 160 148.8l-8.8 7z"
      />
    </svg>
  </span>
</template>

<script>
export default {
  name: "icons",
  props: {
    name: {
      type: String,
    },
    // bordColor: {
    //   type: String,
    // },
    // size: {
    //   type: String,
    // },
  },
  methods: {
    returnIconSize(size) {
      if (size === "x-small") {
        return "14";
      } else if (size === "small") {
        return "18";
      } else if (size === "large") {
        return "24";
      } else if (size === "x-large") {
        return "28";
      } else {
        return "22";
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/global.scss";
</style>
